import {
  Avatar,
  Button,
  CheckboxOptionType,
  Flex,
  Modal,
  TableColumnsType,
  Tooltip,
} from 'antd'
import dayjs from 'dayjs'
import { useAttemptListener } from 'dev-masters-react-kit'
import { useMemo, useState } from 'react'
import { HiMiniNoSymbol } from 'react-icons/hi2'
import { MdDelete, MdEdit, MdOutlineSort } from 'react-icons/md'
import { attemptPlaySong } from '../redux/appSlice'
import { Song } from '../redux/songsSlice'
import { store, useAppDispatch } from '../redux/store'
import { FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa'

const defaultActiveColumns = ['title', 'artist', 'action']

const basicColumns: TableColumnsType<Song> = [
  {
    title: 'Picture',
    dataIndex: 'picture',
    key: 'picture',
    width: 80,
    render: (value) => <Avatar shape="square" src={value} icon={<HiMiniNoSymbol />} />,
  },
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Artist',
    dataIndex: 'artist',
    key: 'artist',
  },
  {
    title: (
      <>
        <div>Created</div>
        <FaSortAmountDown />
        <FaSortAmountUp />
      </>
    ),
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (value: Song['createdAt']) => dayjs(value).toString(),
  },
  {
    title: 'Modified',
    dataIndex: 'modifiedAt',
    key: 'modifiedAt',
    render: (value: Song['modifiedAt']) => value && dayjs(value).toString(),
  },
  {
    title: 'Duration',
    dataIndex: 'duration',
    key: 'duration',
  },
]

export default function useAllTrackDynamicColumns({
  actions,
}: Partial<Pick<SongActionsInterface, 'actions'>>) {
  const [displayedColumns, setDisplayedColumns] = useState(defaultActiveColumns)
  const allColumns: TableColumnsType<Song> = useMemo(() => {
    return actions
      ? [
          ...basicColumns,
          {
            title: 'Action',
            key: 'action',
            width: 120,
            render: (_, song) => <SongActions song={song} actions={actions} />,
          },
        ]
      : basicColumns
  }, [])

  const columns = allColumns.map((item) => ({
    ...item,
    hidden: !displayedColumns.includes(item.key as string),
  }))

  const checkBoxOptions = allColumns.map(({ key, title }) => ({
    label: title,
    value: key,
  })) as CheckboxOptionType[]
  return {
    columns,
    checkBoxOptions,
    displayedColumns,
    setDisplayedColumns,
  }
}

export interface SongActionsInterface {
  song: Song
  actions?: {
    onEditSong: (song: Song) => void
    onDeleteSong: (song: Song) => void
    // onPlaySong: (song: Song) => void
  }
}
function SongActions({ song, actions }: SongActionsInterface) {
  const dispatch = useAppDispatch()
  // const { howl } = usePlayerContext()
  // useAttemptListener({
  //   attempt: attemptPlaySong,
  //   store: store,
  //   onFulfilled: () => howl?.play(),
  // })

  return (
    <Flex gap={10}>
      {/*       <Tooltip title="Play song">
        <Button
          onClick={() => {
            dispatch(attemptPlaySong(song))
          }}
          icon={<MdOutlinePlayCircle />}
          size="small"
        />
      </Tooltip> */}
      <Tooltip title="Edit song">
        <Button
          onClick={() => actions?.onEditSong(song)}
          icon={<MdEdit />}
          size="small"
        />
      </Tooltip>
      {/* <Tooltip title="Add to the playlist">
          <Button
            // onClick={() => }
            icon={<CgPlayListAdd />}
            size="small"
          />
        </Tooltip> */}
      <Tooltip title="Delete">
        <Button
          onClick={() => {
            Modal.confirm({
              title: `Are you sure you want to delete this song? `,
              content: (
                <Flex vertical>
                  <span>Song title: {song.title}</span>
                  <span>Artist: {song.artist}</span>
                </Flex>
              ),
              onOk: () => actions?.onDeleteSong(song),
            })
          }}
          icon={<MdDelete />}
          size="small"
        />
      </Tooltip>
    </Flex>
  )
}
